import { useContext } from 'react';
import { SearchProcessContext } from '../contexts/SearchProcessContext';
// ----------------------------------------------------------------------

const useSearchProcess = () => useContext(SearchProcessContext);
export default useSearchProcess;
